export default {"src":"/_next/static/media/Sciatica and Nerve Pain.779eb23b.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};